var logger = require('./logger');

var Store = require('./store');

var Client = require('./client');

module.exports = {
  logger: logger,
  createLogger: logger.create,
  Store: Store,
  createStore: function createStore(name) {
    return new Store(name);
  },
  Client: Client
};